var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.695 86.695"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 823"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 822"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 378",
    d: "M43.348 0A43.348 43.348 0 1086.7 43.348 43.4 43.4 0 0043.348 0zm0 80.5A37.155 37.155 0 1180.5 43.348 37.2 37.2 0 0143.348 80.5z",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Uni\\xF3n 2",
    d: "M40.252 60.893V46.444H25.806a3.1 3.1 0 110-6.193h14.446V25.806a3.1 3.1 0 116.193 0v14.446h14.448a3.1 3.1 0 010 6.193H46.444v14.448a3.1 3.1 0 01-6.193 0z",
    fill: "#fff"
  })));
}

export default SvgAddinline;